import { cover, hideText } from "polished";
import styled, { css } from "styled-components";
import { zIndex } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import Button from "../../quarks/Button";
import Link from "../../quarks/Link";
import { backgroundColor, largeBreakpointValue, paddingSpace } from "./AdvancedProductCardMol.settings";
import Footer from "./Footer";
import MainContent from "./MainContent";
var baseContainerStyles = css(function (_ref) {
  var theme = _ref.theme;
  return css(["", ";display:flex;flex-direction:column;flex-grow:1;padding:", ";overflow:hidden;border-radius:", ";background-color:", ";box-shadow:", ";", "{&:hover{box-shadow:", ";}}"], transition("box-shadow"), space(paddingSpace), getBorderRadius(theme, "large"), getColor(theme, backgroundColor), getBoxShadow(theme, "small"), breakpoint("small", largeBreakpointValue), getBoxShadow(theme, "large"));
});
export var Card = styled.article.withConfig({
  componentId: "sc-tpkp7w-0"
})(["display:flex;position:relative;"]);
export var DefaultContainer = styled.div.withConfig({
  componentId: "sc-tpkp7w-1"
})(function (_ref2) {
  var $isHidden = _ref2.$isHidden;
  return css(["", ";", "{", "}", "{cursor:pointer;}"], baseContainerStyles, breakpoint(largeBreakpointValue), $isHidden && css(["visibility:hidden;"]), breakpoint("small", largeBreakpointValue));
});
export var DesktopDetailedContainer = styled.div.withConfig({
  componentId: "sc-tpkp7w-2"
})(function (_ref3) {
  var $isVisible = _ref3.$isVisible;
  return css(["", ";", "{", "}", "{display:none;}"], baseContainerStyles, breakpoint(largeBreakpointValue), $isVisible ? css(["position:absolute;top:0;right:0;left:0;"]) : css(["display:none;"]), breakpoint("small", largeBreakpointValue));
});
export var CloseButton = styled(Button).withConfig({
  componentId: "sc-tpkp7w-3"
})(function (_ref4) {
  var theme = _ref4.theme;
  return css(["position:fixed;z-index:", ";top:", ";right:", ";padding:", ";border-radius:", ";background:", ";box-shadow:", ";&:hover{opacity:0.8;}"], zIndex.AdvancedProductCardMolMobileDetails + 1, space(paddingSpace), space(paddingSpace), space(1), getBorderRadius(theme, "huge"), getColor(theme, backgroundColor), getBoxShadow(theme, "small"));
});
export var StyledMainContent = styled(MainContent).withConfig({
  componentId: "sc-tpkp7w-4"
})(function (_ref5) {
  var $minHeight = _ref5.$minHeight;
  return css(["", " ", "{margin:", ";padding:", ";overflow-x:hidden;overflow-y:auto;}"], $minHeight ? css(["min-height:", ";"], unit($minHeight)) : null, breakpoint("small", largeBreakpointValue), space(-1 * paddingSpace), space(paddingSpace));
});
export var StyledFooter = styled(Footer).withConfig({
  componentId: "sc-tpkp7w-5"
})(function (_ref6) {
  var $isDetailedView = _ref6.$isDetailedView,
    theme = _ref6.theme;
  return css(["margin-top:", ";", ""], space(2), $isDetailedView && css(["", "{margin:auto ", " ", ";padding:", " ", " ", ";border-top:", " solid ", ";}"], breakpoint("small", largeBreakpointValue), space(-1 * paddingSpace), space(-1 * paddingSpace), space(2), space(paddingSpace), space(paddingSpace), unit(1), getBorderColor(theme, backgroundColor, "low")));
});
export var BoxLink = styled(Link).withConfig({
  componentId: "sc-tpkp7w-6"
})(["", ";", ";"], cover(), hideText());